var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white border rounded p-3" },
    [
      _c(
        "b-row",
        { staticClass: "g-3 mb-3" },
        _vm._l(_vm.normalizedFilters, function (filter, index) {
          return _c(
            "b-col",
            {
              key: index,
              attrs: {
                sm: filter.colSm || "6",
                md: filter.colMd,
                lg: filter.colLg || "3",
              },
            },
            [
              _c("app-card", {
                attrs: {
                  label: _vm.$t(filter.labelKey),
                  icon: filter.icon || "fa-solid fa-filter",
                  "control-id":
                    filter.type === "datetime"
                      ? filter.id + "-data"
                      : filter.id,
                  mandatory: filter.required || false,
                  autocomplete: filter.autocomplete || "off",
                  variant: "light",
                  size: "md",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var controlId = ref.controlId
                        var mandatory = ref.mandatory
                        var autocomplete = ref.autocomplete
                        return [
                          filter.type === "text"
                            ? _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  id: controlId,
                                  type: "text",
                                  autocomplete: autocomplete,
                                  placeholder: _vm.$t(
                                    filter.placeholderKey || filter.labelKey
                                  ),
                                  "aria-required": mandatory,
                                },
                                domProps: { value: filter.value },
                                on: {
                                  input: function ($event) {
                                    _vm.updateFilter(
                                      filter.prop,
                                      $event.target.value.trim()
                                    )
                                  },
                                },
                              })
                            : filter.type === "select"
                            ? _c(
                                "select",
                                {
                                  staticClass: "form-control",
                                  attrs: {
                                    id: controlId,
                                    autocomplete: autocomplete,
                                    "aria-required": mandatory,
                                  },
                                  domProps: { value: filter.value },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateFilter(
                                        filter.prop,
                                        $event.target.value
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t(filter.defaultOptionKey))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(filter.options, function (option) {
                                    return _c(
                                      "option",
                                      {
                                        key: option.value,
                                        domProps: { value: option.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              option.label ||
                                                _vm.$t(option.labelKey)
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              )
                            : filter.type === "datetime"
                            ? _c("datetime-picker-custom", {
                                attrs: {
                                  format: filter.format || "DD/MM/YYYY H:i:s",
                                  id: filter.id,
                                  customInputClass: "form-control",
                                  maxLength: filter.maxLength || 19,
                                  placeholderValue: _vm.$t(
                                    "common.datetime_picker_empty_date"
                                  ),
                                  "is-mandatory": filter.required || false,
                                  value: filter.value,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateFilter(filter.prop, $event)
                                  },
                                },
                              })
                            : filter.type === "date"
                            ? _c("datetime-picker-custom", {
                                attrs: {
                                  format: filter.format || "DD/MM/YYYY",
                                  id: controlId,
                                  customInputClass: "form-control",
                                  maxLength: filter.maxLength || 10,
                                  placeholderValue: _vm.$t(
                                    "common.date_picker_empty_date"
                                  ),
                                  "is-mandatory": filter.required || false,
                                  value: filter.value,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateFilter(filter.prop, $event)
                                  },
                                },
                              })
                            : filter.type === "switch"
                            ? _c("div", { staticClass: "switch-container" }, [
                                _c("input", {
                                  staticClass: "switch-checkbox",
                                  attrs: { id: controlId, type: "checkbox" },
                                  domProps: { checked: filter.value },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateFilter(
                                        filter.prop,
                                        $event.target.checked
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "switch-label",
                                    attrs: { for: controlId },
                                  },
                                  [
                                    _c("span", { staticClass: "switch-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          filter.value
                                            ? _vm.$t(
                                                filter.activeKey ||
                                                  "common.active"
                                              )
                                            : _vm.$t(
                                                filter.inactiveKey ||
                                                  "common.inactive"
                                              )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : filter.type === "multiselect"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-dropdown",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        text: _vm.getMultiselectDisplay(filter),
                                        variant: "outline-secondary",
                                        id: controlId,
                                      },
                                    },
                                    [
                                      _c(
                                        "b-dropdown-form",
                                        _vm._l(
                                          filter.options,
                                          function (option, index) {
                                            return _c(
                                              "div",
                                              {
                                                key:
                                                  controlId +
                                                  "-option-" +
                                                  index,
                                                staticClass: "p-2",
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    attrs: {
                                                      checked: option.selected,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.updateMultiselect(
                                                          filter.prop,
                                                          option,
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          option.label ||
                                                            _vm.$t(
                                                              option.labelKey
                                                            )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "gx-2" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("filter.clr_fltr_field"),
                  icon: "fa-light fa-eraser",
                  variant: "secondary",
                  outline: "",
                  block: true,
                  "aria-label": _vm.$t("filter.clr_fltr_field"),
                },
                on: { click: _vm.clearFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.srch"),
                  icon: "fa-light fa-magnifying-glass",
                  variant: "primary",
                  block: true,
                  "aria-label": _vm.searchAriaLabel,
                },
                on: { click: _vm.applyFilters },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }